import Api from '../global/api';

export function berthsLoad () {
    return async dispatch => {

        // Loading
        dispatch({
            type: 'BERTHS_LOAD',
            status: 'LOADING',
            payload: null
        })

        let active_profile = await Api.getLocal('_bvap');
        if(active_profile !== null){
            Api.req(`/berths/${active_profile}`, 'GET').then(
                res => {

                    Api.setLocal('berths', res.result);

                    dispatch({
                        type: 'BERTHS_LOAD',
                        status: 'OK',
                        payload: res.result
                    })
                },
                err => {
                    // Login error
                    dispatch({
                        type: 'BERTHS_LOAD',
                        status: 'error',
                        payload: typeof err.msg === 'string' ? err.msg : 'Sorry we were unable to load your berths'
                    })
                }
            )
        }

    }
}

export function berthAdd (payload) {
    return dispatch => {

        // Loading
        dispatch({
            type: 'BERTH_ADD',
            status: 'OK',
            payload: payload
        })

        return 'success';

    }
}

export function berthUpdate (payload) {
    return async dispatch => {

        // Loading
        dispatch({
            type: 'BERTH_UPDATE',
            status: 'OK',
            payload: payload
        })
        
    }
}